import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

interface FeatureFlag {
  [x: string]: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  public is_oidc_auth_enabled = false;

  constructor(private http: HttpClient) { }

  async start() {
    this.is_oidc_auth_enabled = await this.getOidcAuthEnabled();
  }

  async getOidcAuthEnabled() {
    const response = await this.http.get(`${environment.api}/feature-flags/oidc-auth`).toPromise();
    return response as boolean;
  }
}
